export default __webpack_public_path__ + "static/media/evoUSDC.a982c35e.svg";